<template>
  <div class="organism product-grid-picker sm:py-20 py-8 px-8" :class="organism.removeMargin">
    <h1 class="text-center text-3xl font-semibold md:text-5xl title-1 font-archer text-[#1a2937]">{{ gridItems?.title1 }}</h1>
    <div class="text-center font-arial text-lg text-[#6b7280] pt-5 pb-10 max-w-[820px] m-auto" v-html="gridItems.description"></div>
    <div
      :class="[
        'items-self justify-center text-gray-800 flex flex-wrap gap-8'
      ]"
    >
      <!-- Iterate over productPicker array -->
      <div v-for="product in productPicker" :key="product.id" class="product-item z-0 w-full max-w-sm mb-2 text-center item">
        <NuxtLink :to="product.uri">
          <h3 class="pb-2 text-2xl font-semibold font-archer">
            {{ product.title }}
          </h3>
          <div
            class="border border-neutral-400 drop-shadow-lg hover:drop-shadow-md"
          >
            <figure class="relative w-full h-56">
              <img
              :src="getImageSource(product)"
              class="object-cover w-full h-full"
              />
              <span
                v-if="getMsg(product)"
                class="absolute left-0 px-4 py-[5px] text-white uppercase top-6 font-ubuntu bg-snipe-blue"
              >
                {{ getMsg(product) }}
              </span>
              <span
                v-if="getBasePrice(product)"
                :class="[
                  'absolute right-0 px-4 py-[5px] text-white uppercase top-6 font-ubuntu bg-bc-purple'
                ]"
                v-html="getBasePrice(product)"
              >
              </span>
            </figure>
              <!--<p class="text-center font-ubuntu p-2 bg-gray-200 text-[18px] font-bold" v-if="getBasePrice(product)" v-html="getBasePrice(product)"></p>-->
            <div
              class="flex px-2 pt-3 pb-4 bg-white justify-evenly details gap-4 empty:p-0"
            >
              <div v-if="getBeds(product)" class="flex flex-col">
                <span class="text-[22px]">
                  {{ getBeds(product) }}
                </span>
                <span class="text-xs font-bold font-arial">BEDS</span>
              </div>
              <div v-if="getBaths(product)" class="flex flex-col">
                <span class="text-[22px]">
                  {{ getBaths(product) }}
                </span>
                <span class="text-xs font-bold font-arial">BATH</span>
              </div>
              <div v-if="getSqFt(product)" class="flex flex-col">
                <span class="text-[22px]">
                  {{ getSqFt(product) }}
                </span>
                <span class="text-xs font-bold font-arial">SQ. FT.</span>
              </div>
            </div>
          </div>
        </NuxtLink>
      </div>

    </div>
</div>
</template>

<style>
.product-grid-picker {

}
</style>

<script setup>
const props = defineProps({
  organism: Object,
});

const gridItems = ref(props.organism);
//console.log(gridItems.value.title1);

const productPicker = computed(() => gridItems.value.productPicker);
//console.log(productPicker.value);

function getBasePrice(product) {
  let price;
  let prefix = '';

  if (product?.floorplanDetails) {
    prefix = '<i>From</i> $';
    price = product.floorplanDetails.basePrice;
  } else if (product?.modelDetails) {
    prefix = '<i>From</i> $';
    price = product.modelDetails.floorplan.floorplanDetails.basePrice;
  } else if (product?.qmiHomeDetails) {
    prefix = '$';
    price = product.qmiHomeDetails.price;
  }

  // Return null or a default value if none of the conditions are met
  if (price === null || price === undefined) {
    return null;
  }

  // Format the price with commas
  const formattedPrice = new Intl.NumberFormat('en-US').format(price);

  return `${prefix}${formattedPrice}`;
}

function getImageSource(product) {
  if (product.floorplanDetails?.elevations?.length > 0) {
    return product.floorplanDetails.elevations[0].sourceUrl;
  }
  else if (product.featuredImage?.node) {
    return product.featuredImage.node.sourceUrl;
  }

  // Return null or a default value if none of the conditions are met
  return null;
}

function getBeds(product) {
  if (product?.floorplanDetails) {
    // Assuming detailMinMax can handle single values as well
    return detailMinMax(product.floorplanDetails.bedroomsMin, product.floorplanDetails.bedroomsMax);
  } else if (product?.modelDetails) {
    return detailMinMax(
      product.modelDetails.floorplan.floorplanDetails.bedroomsMin,
      product.modelDetails.floorplan.floorplanDetails.bedroomsMax
    );
  } else if (product?.qmiHomeDetails) {
    // Assuming qmiHomeDetails only has a single value for bedrooms
    return product.qmiHomeDetails.bedrooms;
  }

  // Return null or a default value if none of the conditions are met
  return null;
}

function getBaths(product) {
  if (product?.floorplanDetails) {
    // Assuming detailMinMax can handle single values as well
    return detailMinMax(product.floorplanDetails.bathroomsMin, product.floorplanDetails.bathroomsMax);
  } else if (product?.modelDetails) {
    return detailMinMax(
      product.modelDetails.floorplan.floorplanDetails.bathroomsMin,
      product.modelDetails.floorplan.floorplanDetails.bathroomsMax
    );
  } else if (product?.qmiHomeDetails) {
    // Assuming qmiHomeDetails only has a single value for bathrooms
    return product.qmiHomeDetails.bathrooms;
  }

  // Return null or a default value if none of the conditions are met
  return null;
}

function getSqFt(product) {
  if (product?.floorplanDetails) {
    return product?.floorplanDetails?.finishedSqrFt || product?.floorplanDetails?.mainSqrFt;
  } else if (product?.modelDetails) {
    return product?.modelDetails?.floorplan?.floorplanDetails?.finishedSqrFt || product?.modelDetails?.floorplan?.floorplanDetails?.mainSqrFt;
  } else if (product?.qmiHomeDetails) {
    return product?.qmiHomeDetails?.finishedSqrFt || product?.qmiHomeDetails?.mainSqrFt;
  }

  // Return null or a default value if none of the conditions are met
  return null;
}

function getMsg(product) {
  const statusMessage = product?.productStatus?.statusMessage;
  const statusCustom = product?.productStatus?.statusCustom;

  if (Array.isArray(statusMessage) && statusMessage[1] === "Custom Message") {
    return statusCustom;
  }

  return statusMessage ? statusMessage[1] : null;
}

</script>
